import{BehaviorSubject as o}from"rxjs";var i=new o(null);export{i as a};
//# sourceMappingURL=chunk-64VNNNML.js.map